import { Tin } from "./Tin";
import { DateTime } from "luxon";
export class SwedishTin extends Tin {
    validate(tin) {
        const normalizedTin = this.getNormalizedTin();
        return (normalizedTin.length === 12 &&
            this.isValidDate(normalizedTin) &&
            this.isValidLuhn(normalizedTin));
    }
    getNormalizedTin() {
        let normalizedPnr = this.tin.replace(/-/g, "").replace(/ /g, "");
        if (normalizedPnr.includes("+") && normalizedPnr.length < 12) {
            const pnrYear = `19${normalizedPnr.substr(0, 2)}`;
            const currentYear = new Date().getFullYear().toString();
            if (parseInt(currentYear, 10) - parseInt(pnrYear, 10) < 100) {
                normalizedPnr = `18${normalizedPnr}`.replace("+", "");
            }
            else {
                normalizedPnr = `19${normalizedPnr}`.replace("+", "");
            }
        }
        else if (normalizedPnr.includes("+")) {
            normalizedPnr = normalizedPnr.replace("+", "");
        }
        else if (normalizedPnr.length === 10) {
            const shortYear = new Date().getFullYear().toString().substr(2);
            if (parseInt(normalizedPnr.substr(0, 2), 10) <= parseInt(shortYear, 10)) {
                normalizedPnr = `20${normalizedPnr}`;
            }
            else {
                normalizedPnr = `19${normalizedPnr}`;
            }
        }
        return normalizedPnr;
    }
    isValidLuhn(tin) {
        let num = [];
        for (let i = 2; i < tin.length - 1; i++) {
            let val = parseInt(tin[i], 10);
            if (i % 2 === 0) {
                val = val * 2;
            }
            num = [...num, ...val.toString().split("")];
        }
        const controlNumber = (10 - (num.reduce((acc, curr) => acc + parseInt(curr, 10), 0) % 10)) % 10;
        return parseInt(tin[tin.length - 1], 10) === controlNumber;
    }
    isValidDate(pnr) {
        const date = DateTime.fromFormat(pnr.substring(0, 8), "yyyyMMdd");
        return date.isValid;
    }
    getBirthDate() {
        if (!this.valid) {
            return undefined;
        }
        const tin = this.getNormalizedTin();
        return tin.slice(0, 4) + "-" + tin.slice(4, 6) + "-" + tin.slice(6, 8);
    }
}
